import { Link } from "react-router-dom";
import { columns } from "@/mocks/news";

export default function Footer() {
  return (
    <footer className="w-full bg-accent-900 text-accent-50">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-accent-500 text-xl text-accent-950">
                <i className="ri-megaphone-fill"></i>
              </span>
              <span className="font-heading text-2xl font-black text-accent-50">
                98<span className="text-secondary-300">爆料</span>
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-accent-200/90">
              98爆料专注娱乐八卦与明星动态，聚合综艺内幕、剧组消息与艺人行程，
              每日更新热门瓜料，带你看透娱乐圈台前幕后。吃瓜群众聚集地，点开就看最新娱乐猛料。
            </p>
            <div className="mt-5 flex items-center gap-3 text-accent-100">
              <a
                href="#"
                onClick={(e) => e.preventDefault()}
                aria-label="微博"
                className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-700/60 text-base hover:bg-accent-500 hover:text-accent-950"
              >
                <i className="ri-weibo-fill"></i>
              </a>
              <a
                href="#"
                onClick={(e) => e.preventDefault()}
                aria-label="微信"
                className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-700/60 text-base hover:bg-accent-500 hover:text-accent-950"
              >
                <i className="ri-wechat-fill"></i>
              </a>
              <a
                href="#"
                onClick={(e) => e.preventDefault()}
                aria-label="哔哩哔哩"
                className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-700/60 text-base hover:bg-accent-500 hover:text-accent-950"
              >
                <i className="ri-bilibili-line"></i>
              </a>
              <a
                href="#"
                onClick={(e) => e.preventDefault()}
                aria-label="抖音"
                className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-700/60 text-base hover:bg-accent-500 hover:text-accent-950"
              >
                <i className="ri-music-2-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="flex items-center gap-1.5 text-sm font-bold text-secondary-200">
              <i className="ri-grid-fill text-accent-300"></i>
              栏目导航
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              {columns.map((c) => (
                <li key={c.slug}>
                  <Link
                    to={`/column/${c.slug}`}
                    className="flex items-center gap-1.5 text-accent-100/90 hover:text-secondary-200"
                  >
                    <i className={`${c.icon} text-accent-400`}></i>
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="flex items-center gap-1.5 text-sm font-bold text-secondary-200">
              <i className="ri-links-fill text-accent-300"></i>
              快捷入口
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <Link to="/" className="text-accent-100/90 hover:text-secondary-200">
                  今日瓜榜
                </Link>
              </li>
              <li>
                <Link to="/column/star" className="text-accent-100/90 hover:text-secondary-200">
                  明星动态
                </Link>
              </li>
              <li>
                <Link to="/column/crew" className="text-accent-100/90 hover:text-secondary-200">
                  剧组消息
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-accent-100/90 hover:text-secondary-200">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-accent-700/50 pt-6 text-xs text-accent-300/80 sm:flex-row">
          <p>© 2026 98爆料 98Baoliao. 保留所有权利 · 本站内容仅供参考，非权威信息来源</p>
          <p className="flex items-center gap-1.5">
            <i className="ri-verified-badge-line text-accent-400"></i>
            理性吃瓜 · 文明追星 · 实事求是
          </p>
        </div>
      </div>
    </footer>
  );
}